const SDK_VERSION = '7.40.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
